import { render, staticRenderFns } from "./GroupPriceChart.vue?vue&type=template&id=b68b92b6&scoped=true"
import script from "./GroupPriceChart.vue?vue&type=script&lang=js"
export * from "./GroupPriceChart.vue?vue&type=script&lang=js"
import style0 from "./GroupPriceChart.vue?vue&type=style&index=0&id=b68b92b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68b92b6",
  null
  
)

export default component.exports